import { LANG_DEFAULT, LANGUAGES, LANGUAGES_ACTIVE_LIST } from '@/base/const/lang.const'
import { loadLanguage } from '@/base/i18n/index'
import { CookieClass } from '@/base/class/cookie.class'
import { COOKIE_LANG } from '@/base/const/cookies.const'

const state = {
  current: LANG_DEFAULT,
  loading: false,
}
const mutations = {
  SET_CURRENT_LANGUAGE(state, value) {
    state.current = value
  },
  SET_LANG_LOADING(state, value) {
    state.loading = value
  },
}
const actions = {
  setLanguage({ commit, dispatch, rootState }, payload) {
    const value = typeof payload === 'string' ? payload : payload.value
    const silent = payload?.silent || false

    if (silent) {
      CookieClass.setCookie(COOKIE_LANG, value)
      return loadLanguage(value.toLowerCase()).then(() => {
        commit('SET_CURRENT_LANGUAGE', value)
        if (rootState.payment.paymentData && rootState.payment.paymentData.paywayGroups) {
          dispatch('getPaywaysLanguageData')
        }
        dispatch('refreshActiveRegulationLanguage')
      })
    }
    commit('SET_LANG_LOADING', true)
    CookieClass.setCookie(COOKIE_LANG, value)

    // Bez sztucznych opóźnień: teksty podmieniają się w chwili wczytania paczki tłumaczeń.
    // Wcześniej było tu 500 ms „minimalnego czasu ładowania" i 100 ms przed zdjęciem flagi -
    // miały upłynnić loader, który zasłaniał paywall. Loader zniknął (patrz isLoading w widokach),
    // więc te opóźnienia tylko zwlekały z podmianą języka.
    return loadLanguage(value.toLowerCase())
      .then(() => {
        commit('SET_CURRENT_LANGUAGE', value)
        if (rootState.payment.paymentData && rootState.payment.paymentData.paywayGroups) {
          dispatch('getPaywaysLanguageData')
        }
        // Regulamin kanału jest KOPIĄ w `payment.form`, nie getterem - bez tego zostaje w języku
        // z chwili wyboru kanału. → doc/dokumentacja/platnosci.md
        dispatch('refreshActiveRegulationLanguage')
      })
      .catch(() => {})
      .finally(() => {
        commit('SET_LANG_LOADING', false)
      })
  },
}
const getters = {
  getCurrentLanguage(state, getters) {
    const languagesList = getters.getAvailableLanguagesList
    if (!state.current || !languagesList.includes(state.current)) {
      return LANG_DEFAULT
    }
    return state.current
  },
  getAvailableLanguagesList(state, getters, rootState) {
    const paymentData = rootState.payment.paymentData
    const confirmationData = rootState.confirmation.data
    if (paymentData) {
      const languagesAvailable = paymentData.languageData?.languagesAvailable || []
      return LANGUAGES_ACTIVE_LIST.filter((x) => languagesAvailable.includes(x))
    } else if (confirmationData) {
      const languagesAvailable = confirmationData.languageData?.languagesAvailable || []
      return LANGUAGES_ACTIVE_LIST.filter((x) => languagesAvailable.includes(x))
    }
    return LANGUAGES_ACTIVE_LIST
  },
  isDefaultLangActive(state) {
    return state.current === LANG_DEFAULT
  },
  isLangForYourCxActive(state) {
    return [LANGUAGES.pl, LANGUAGES.de].includes(state.current)
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
